const contentTypes = {
  ARTICLE: "ARTICLE",
  BUNDLE: "BUNDLE",
  GENERATION_GENIUS_VIDEO: "GENERATION_GENIUS_VIDEO",
  INTERACTIVE_VIDEO: "INTERACTIVE_VIDEO",
  PHET_SIMULATION: "PHET_SIMULATION",
  TUVA_DATASET: "TUVA_DATASET",
} as const;

export type ContentType = (typeof contentTypes)[keyof typeof contentTypes];

export const UNLEVELLED_CONTENT_TYPES: ContentType[] = [
  contentTypes.GENERATION_GENIUS_VIDEO,
  contentTypes.PHET_SIMULATION,
  contentTypes.TUVA_DATASET,
];

export const IFRAME_CONTENT_TYPES: ContentType[] = [
  contentTypes.PHET_SIMULATION,
  contentTypes.TUVA_DATASET,
];

export default contentTypes;
